import type { BodyScrollOptions } from 'body-scroll-lock';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { useEffect } from 'react';

const useBodyScrollLock = (
  lock: boolean,
  element: HTMLElement | null,
  options?: BodyScrollOptions
) => {
  useEffect(() => {
    if (!element) {
      return;
    }
    lock ? disableBodyScroll(element, options) : enableBodyScroll(element);

    return () => element && enableBodyScroll(element);
  }, [lock, element, options]);
};

export default useBodyScrollLock;
